var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVisaIncLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    fill: "none",
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 28C0 12.536 12.536 0 28 0s28 12.536 28 28-12.536 28-28 28S0 43.464 0 28"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1434cb",
    d: "M34.365 21.21c-2.978 0-5.653 1.55-5.653 4.393 0 3.276 4.724 3.5 4.724 5.129 0 .687-.8 1.31-2.145 1.31-1.922 0-3.363-.863-3.363-.863l-.608 2.876s1.649.735 3.858.735c3.267 0 5.829-1.614 5.829-4.521 0-3.451-4.74-3.675-4.74-5.193 0-.543.657-1.134 2.002-1.134 1.52 0 2.77.623 2.77.623l.608-2.78c-.016 0-1.377-.575-3.282-.575m-27.285.208-.08.415s1.249.224 2.386.687c1.457.527 1.553.83 1.81 1.773l2.673 10.273h3.587l5.492-13.148h-3.57l-3.54 8.947-1.44-7.59c-.128-.862-.801-1.357-1.634-1.357zm17.31 0-2.803 13.148h3.41l2.787-13.148zm18.99 0c-.817 0-1.25.431-1.57 1.198l-4.995 11.95h3.57l.689-1.997h4.355l.417 1.997H49l-2.738-13.148zm.464 3.562 1.057 4.937h-2.834z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisaIncLogo);
export default __webpack_public_path__ + "static/media/visa_inc_logo.9062ba250a8d6054b545e0244055b901.svg";
export { ForwardRef as ReactComponent };